import DetailsFinancingRequest from "./DetailsFinancingRequest";
export default DetailsFinancingRequest;
